/**
 * Purpose of this class is to aggregate anything that really should be a configurable setting
 * so that at least any temporary shortcuts are easily searchable and replaceable.
 *
 */
export default class Global {
  public static SENSOR_TYPES = {
    available: 'Available',
    machineHealth: 'MHM',
    steamTrap: 'STM'
  }

  public static getCurrencySymbol(): string {
    return '$'
  }

  public static getCurrencyString(): string {
    return 'Dollars'
  }

  public static SUMMARY_PAGES = [
    'Eversensor Management',
    'Manage Evergateways',
    'Machine Summary',
    'Steam Trap Summary',
    'Customers',
    'Machine Dashboard',
    'Users',
    'APICredentials',
    'Webhooks'
  ]

  public static GRID_NAMES = [
    'eversensors',
    'evergateways',
    'machines',
    'steamtraps',
    'groundTruth',
    'sensorData',
    'reportingSensors',
    'customers',
    'users'
  ]

  public static KNOWLEDGE_BASE_URLS = {
    home: 'https://support.ims.shoplogix.com/',
    evergateway: 'https://support.ims.shoplogix.com/hardware/'
  }

  public static AUTH0_URLS = {
    userMetadata: 'https://sr2.ca/claims/user_metadata',
    appMetadata: 'https://sr2.ca/claims/app_metadata'
  }

  // Finding 20 — one domain rule. Staff email domains, the single source of truth for
  // every internal-user check. Product-usage analytics from these accounts are dropped
  // at the source (see isInternalEmail in useAnalytics) so PostHog counts customers only.
  public static INTERNAL_EMAIL_DOMAINS = ['everactive.com', 'shoplogix.com']

  // Google Analytics only (useGoogleAnalytics does a substring `includes` on the
  // username). Derived from INTERNAL_EMAIL_DOMAINS so the two never drift; the value
  // is exactly '@everactive.com'.
  public static EVERACTIVE_EMAIL_DOMAIN = `@${Global.INTERNAL_EMAIL_DOMAINS[0]}`

  public static NEW_ITEM_SPECIAL_IDENTIFIER = 'new'
}
